import React from "react";

function SlackClone() {
  return (
    <div>
      <h1>I am slack clone page</h1>
    </div>
  );
}

export default SlackClone;
